// eslint-disable-next-line
export const setHashChannelParams = (hash, channel, additionalParams) => {
  const start = additionalParams ? '&' : '?';

  if (hash && channel) {
    return `${start}hash=${hash}&channel=${channel}`;
  }

  if (hash) {
    return `${start}hash=${hash}`;
  }

  if (channel) {
    return `${start}channel=${channel}`;
  }

  return '';
};
